import React from 'react';
import { ArrowRight, ArrowLeft, AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ScrollArea } from '@/components/ui/scroll-area';

const Step4ReviewResume = ({ wizardData, nextStep, prevStep }) => {
  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4">
          Review Tailored Resume
        </h2>
        <p className="text-lg text-muted-foreground">
          Your resume has been optimized for this job description
        </p>
      </div>

      {/* Analysis Summary */}
      {wizardData.analysis && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Card className="p-4">
            <p className="text-sm text-muted-foreground mb-2">Skills Matched</p>
            <p className="text-2xl font-bold">{wizardData.analysis.skills?.length || 0}</p>
          </Card>
          <Card className="p-4">
            <p className="text-sm text-muted-foreground mb-2">Key Responsibilities</p>
            <p className="text-2xl font-bold">{wizardData.analysis.responsibilities?.length || 0}</p>
          </Card>
          <Card className="p-4">
            <p className="text-sm text-muted-foreground mb-2">Tools Identified</p>
            <p className="text-2xl font-bold">{wizardData.analysis.tools?.length || 0}</p>
          </Card>
        </div>
      )}

      {/* Tools to Validate */}
      {wizardData.toolsToValidate && wizardData.toolsToValidate.length > 0 && (
        <Card className="p-6 border-orange-200 bg-orange-50 dark:bg-orange-950/20 dark:border-orange-900">
          <div className="flex gap-3">
            <AlertCircle className="w-5 h-5 text-orange-600 dark:text-orange-500 flex-shrink-0 mt-0.5" />
            <div className="space-y-2">
              <p className="font-semibold text-orange-900 dark:text-orange-100">Tools to Validate</p>
              <p className="text-sm text-orange-800 dark:text-orange-200">
                These tools were mentioned in the job description but couldn't be verified from your resume:
              </p>
              <div className="flex flex-wrap gap-2 mt-2">
                {wizardData.toolsToValidate.map((tool, index) => (
                  <Badge key={index} variant="outline" className="border-orange-300 text-orange-800 dark:text-orange-300">
                    {tool}
                  </Badge>
                ))}
              </div>
            </div>
          </div>
        </Card>
      )}

      {/* Tailored Resume Preview */}
      <Card className="p-8 bg-white text-slate-900 shadow-lg">
        <ScrollArea className="h-[500px] pr-4">
          <div className="space-y-4">
            <h3 className="text-xl font-bold mb-4">Tailored Resume</h3>
            <div className="whitespace-pre-wrap text-sm leading-relaxed">
              {wizardData.tailoredResume}
            </div>
          </div>
        </ScrollArea>
      </Card>

      <div className="flex justify-between">
        <Button
          data-testid="prev-step-btn"
          variant="outline"
          size="lg"
          onClick={prevStep}
          className="h-12 px-8 font-semibold"
        >
          <ArrowLeft className="mr-2 w-5 h-5" />
          Back
        </Button>
        <Button
          data-testid="next-step-btn"
          size="lg"
          onClick={nextStep}
          className="h-12 px-8 font-semibold transition-all active:scale-95"
        >
          Generate Cover Letter
          <ArrowRight className="ml-2 w-5 h-5" />
        </Button>
      </div>
    </div>
  );
};

export default Step4ReviewResume;
